import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
	title: 'title'               the name show in submenu and breadcrumb (recommend set)
	icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
	path: '/login',
	component: () => import('@/views/login/index'),
	hidden: true
},
// {
// 	path: '/register',
// 	component: () => import('@/views/register/index'),
// 	hidden: true
// },
{
	path: '/404',
	component: () => import('@/views/404'),
	hidden: true
},
// {
// 	path: '/info',
// 	component: () => import('@/views/accountInfo/accountView'),
// 	hidden: true
// },
// {
// 	path: '/info/edit',
// 	component: () => import('@/views/accountInfo/accountInfo'),
// 	hidden: true,
// },
{
	path: '',
	component: Layout,
	redirect: '/home',
	children: [{
		path: 'home',
		name: 'home',
		component: () => import('@/views/home/index'),
		meta: {
			title: '首页',
			icon: 'home'
		}
	}]
}
]

export const asyncRouterMap = [
	//数据看板页
	{
		path: '/dataTable',
		redirect: '/dataTable/index',
		component: Layout,
		name: 'dataTable',
		meta: {
			title: '数据看板页',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'dataTableIndex',
			component: () => import('@/views/dataTable/index'),
			meta: {
				title: '数据看板页',
				icon: 'ums-menu'
			}
		}]
	},
	{
		path: '/datalink',
		redirect: '/datalink/lnk',
		component: Layout,
		name: 'dataLink',
		meta: {
			title: '上链汇总',
			icon: 'ums-menu',
		},
		children: [{
			path: 'lnk',
			name: 'dataLink',
			component: () => import('@/views/dataTable/datalink'),
			meta: {
				title: '上链汇总',
				icon: 'ums-menu'
			}
		}]
	},
	//客户管理
	{
		path: '/brandOwner',
		redirect: '/brandOwner/index',
		component: Layout,
		name: 'brandOwner',
		meta: {
			title: '客户管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'brandOwnerIndex',
			component: () => import('@/views/brandOwner/index'),
			meta: {
				title: '客户管理',
				icon: 'ums-menu'
			}
		}]
	},
	//商户管理
	{
		path: '/merchant',
		redirect: '/merchant/index',
		component: Layout,
		name: 'merchant',
		meta: {
			title: '商户管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'merchantIndex',
			component: () => import('@/views/merchant/index'),
			meta: {
				title: '商户管理',
				icon: 'ums-menu'
			}
		}]
	},
	// 平台审核页面
	{
		path:'/platform',
		component:Layout,
		redirect:'/platform/index',
		name:'PlatForm',
		meta:{title:'平台审核',icon:'ums-menu'},
		children:[{
			path:'index',
			name:'PlatformIndex',
			component:()=>import('@/views/platform/index'),
			meta:{title:'平台审核',icon:'ums-menu'}
		}]
	},
	{
		path:'/productBatch',
		component:Layout,
		redirect:'/productBatch/index',
		name:'ProductBatch',
		meta:{title:'机构检测',icon:'ums-menu'},
		children:[{
			path:'index',
			meta:{title:'机构检测',icon:'ums-menu'},
			name:'ProductBatchIndex',
			component:()=>import('@/views/productBatch/index')
		}]
	},
	//溯源批次管理
	{
		path: '/traceBatch',
		redirect: '/traceBatch/index',
		component: Layout,
		name: 'traceBatch',
		meta: {
			title: '溯源批次管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'traceBatchIndex',
			component: () => import('@/views/traceBatch/index'),
			meta: {
				title: '溯源批次管理',
				icon: 'ums-menu'
			}
		}]
	},
	//溯源批次审核
	{
		path: '/traceBatch/examine',
		redirect: '/traceBatch/examine/index',
		component: Layout,
		name: 'traceBatchExamine',
		meta: {
			title: '溯源批次管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'traceBatchExamineIndex',
			component: () => import('@/views/traceBatchExamine/traceBatchExamine'),
			meta: {
				title: '溯源批次管理审核',
				icon: 'ums-menu'
			},
		}]
	},
	//商品管理
	{
		path: '/product',
		redirect: '/product/index',
		component: Layout,
		name: 'product',
		meta: {
			title: '商品管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'productIndex',
			component: () => import('@/views/product/index'),
			meta: {
				title: '商品管理',
				icon: 'ums-menu'
			}
		}]
	},
	//环节模板管理
	{
		path: '/template',
		redirect: '/template/index',
		component: Layout,
		name: 'template',
		meta: {
			title: '环节模板管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'templateIndex',
			component: () => import('@/views/productTemplate/index'),
			meta: {
				title: '环节模板管理',
				icon: 'ums-menu'
			}
		}]
	},
	// 富文本模板管理
	{
		path:'/contentManage',
		redirect:"/contentManage/index",
		component:Layout,
		name:'contentManage',
		meta:{
			title:'我的模板管理',
			icon:'ums-menu'
		},
		children:[{
			path:'index',
			name:"contentIndex",
			component:()=>import("@/views/contentTemplate/index"),
			meta:{
				title:"我的模板管理",
				icon:'ums-menu'
			}
		},{
			path:'productIndex',
			name:'contentProductIndex',
			component:()=>import('@/views/contentPTemplate/productIndex'),
			meta:{
				title:'溯源商品信息模板',
				icon:'ums-menu'
			}
		}]
	},
	//分类管理
	{
		path: '/class',
		redirect: '/class/index',
		component: Layout,
		name: 'class',
		meta: {
			title: '分类管理',
			icon: 'ums-menu',
		},
		children: [{
			path: 'index',
			name: 'classIndex',
			component: () => import('@/views/class/index'),
			meta: {
				title: '分类管理',
				icon: 'ums-menu'
			}
		}]
	},
	//用户权限管理
	{
		path: '/ums',
		component: Layout,
		redirect: '/ums/admin',
		name: 'ums',
		meta: {
			title: '权限',
			icon: 'ums'
		},
		children: [{
			path: 'admin',
			name: 'admin',
			component: () => import('@/views/ums/admin/index'),
			meta: {
				title: '用户列表',
				icon: 'ums-admin'
			}
		},
		{
			path: 'role',
			name: 'role',
			component: () => import('@/views/ums/role/index'),
			meta: {
				title: '角色列表',
				icon: 'ums-role'
			}
		},
		{
			path: 'allocMenu',
			name: 'allocMenu',
			component: () => import('@/views/ums/role/allocMenu'),
			meta: {
				title: '分配菜单'
			},
			hidden: true
		},
		{
			path: 'allocResource',
			name: 'allocResource',
			component: () => import('@/views/ums/role/allocResource'),
			meta: {
				title: '分配资源'
			},
			hidden: true
		},
		{
			path: 'menu',
			name: 'menu',
			component: () => import('@/views/ums/menu/index'),
			meta: {
				title: '菜单列表',
				icon: 'ums-menu'
			}
		},
		{
			path: 'addMenu',
			name: 'addMenu',
			component: () => import('@/views/ums/menu/add'),
			meta: {
				title: '添加菜单'
			},
			hidden: true
		},
		{
			path: 'updateMenu',
			name: 'updateMenu',
			component: () => import('@/views/ums/menu/update'),
			meta: {
				title: '修改菜单'
			},
			hidden: true
		},
		{
			path: 'resource',
			name: 'resource',
			component: () => import('@/views/ums/resource/index'),
			meta: {
				title: '资源列表',
				icon: 'ums-resource'
			}
		},
		{
			path: 'resourceCategory',
			name: 'resourceCategory',
			component: () => import('@/views/ums/resource/categoryList'),
			meta: {
				title: '资源分类'
			},
			hidden: true
		}
		]
	},
	//404
	{
		path: '*',
		redirect: '/404',
		hidden: true
	},
	
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js